export default "__VITE_ASSET__DZ$LwfI7__"